import React from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import { AlertTriangleIcon } from 'lucide-react';
export interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
}
export function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  isLoading = false
}: ConfirmDialogProps) {
  return <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm" data-id="element-143">
      <div className="flex flex-col items-center text-center mb-6" data-id="element-144">
        <div className="w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center mb-4" data-id="element-145">
          <AlertTriangleIcon className="w-6 h-6 text-destructive" data-id="element-146" />
        </div>
        <p className="text-sm text-muted-foreground" data-id="element-147">{message}</p>
      </div>

      <div className="flex justify-end space-x-3 w-full" data-id="element-148">
        <Button variant="outline" onClick={onClose} disabled={isLoading} className="flex-1" data-id="element-149">
          {cancelText}
        </Button>
        <Button variant="destructive" onClick={onConfirm} disabled={isLoading} className="flex-1" data-id="element-150">
          {isLoading ? <div className="flex items-center space-x-2" data-id="element-151">
              <div className="w-4 h-4 border-2 border-destructive-foreground border-t-transparent rounded-full animate-spin" data-id="element-152" />
              <span data-id="element-153">Procesando...</span>
            </div> : confirmText}
        </Button>
      </div>
    </Modal>;
}